import { DDMMYYYStringToDate } from '@rd-web-markets/shared/dist/util/date/dateUtils';
import { Breadcrumb } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import BreadcrumbsPortal from '@rd-web-markets/shared/dist/util/BreadcrumbsPortal';
import { ClaimGroup } from '@rd-web-markets/market/dist/models/ClaimGroup';
import { Loader } from '@rd-web-markets/shared/dist/util/Loader';

export default function FinancialSectionBreadcrumb({ claim, page, claimGroup }) {
  const user = useSelector((state) => state.auth.user);

  if (!claimGroup) {
    return <Loader />
  }

  const claimGroupLink = ClaimGroup.load(claimGroup).getOverviewLink(user);

  return (
    <BreadcrumbsPortal>
      <Breadcrumb>
        <Breadcrumb.Item linkAs={Link} linkProps={{to: `/${user.account_type}`}}>Home</Breadcrumb.Item>
        { user.account_type !== 'customer' &&
          <>
            <Breadcrumb.Item linkAs={Link} linkProps={{to: `/${user.account_type}/companies`}}>Companies</Breadcrumb.Item>
            <Breadcrumb.Item linkAs={Link} linkProps={{to: `/${user.account_type}/companies/${claim.company.id}/master`}}>{claim.company.name}</Breadcrumb.Item>
          </>
        }
        <Breadcrumb.Item
          linkAs={Link}
          linkProps={{
            to: claimGroupLink
          }}>
            {claim.claim_group.name}
        </Breadcrumb.Item>
        <Breadcrumb.Item linkAs={Link} linkProps={{to: `/${user.account_type}/claims/${claim.id}/financial_details/${page}`}}>{DDMMYYYStringToDate(claim.to_date).getFullYear()}</Breadcrumb.Item>
      </Breadcrumb>
    </BreadcrumbsPortal>
  );
}
